import React, { useState } from "react";
import { connect } from "react-redux";
import { Link, withRouter, useParams } from "react-router-dom";
import _ from "lodash";
import LinearChart from "../components/LinearChart";

const TOTAL_AMOUNT = "TOTAL_AMOUNT";
const POS_AMOUNT = "POS_AMOUNT";
const CARD_AMOUNT = "CARD_AMOUNT";
const ONLINE_AMOUNT = "ONLINE_AMOUNT";
const CASH_AMOUNT = "CASH_AMOUNT";

const MainPage = (props) => {
  const [chartLines, setChartLines] = useState([TOTAL_AMOUNT, POS_AMOUNT, CARD_AMOUNT, ONLINE_AMOUNT, CASH_AMOUNT]);
  const { dashboard, eventId } = props;
  console.log('Log_chartLines',chartLines);
  const id = eventId;
  
  const paymentTypes =
    !_.isEmpty(dashboard) && !_.isEmpty(dashboard.saleInfo.sales)
      ? _.mapKeys(dashboard.saleInfo.sales, "paymentType")
      : null;
  const paymentTypeBasedSales = (salesPerDay) => {
    const mappedByPaymentType = _.mapKeys(salesPerDay, "paymentType");
    return {
      کارتخوان: mappedByPaymentType[1] ? mappedByPaymentType[1].totalAmount : 0,
      کارت_به_کارت: mappedByPaymentType[2] ? mappedByPaymentType[2].totalAmount : 0,
      اینترنتی: mappedByPaymentType[3] ? mappedByPaymentType[3].totalAmount : 0,
      نقدی: mappedByPaymentType[4] ? mappedByPaymentType[4].totalAmount : 0,
    };
  };
  const getlines = () => {
    let lines = [];
    if (chartLines.indexOf(TOTAL_AMOUNT) >= 0) {
      lines = [...lines, { color: "#585675", keyName: "مجموع" }];
    }
    if (chartLines.indexOf(POS_AMOUNT) >= 0) {
      lines = [...lines, { color: "#ffb726", keyName: "کارتخوان" }];
    }
    if (chartLines.indexOf(CARD_AMOUNT) >= 0) {
      lines = [...lines, { color: "#0aeefa", keyName: "کارت_به_کارت" }];
    }
    if (chartLines.indexOf(ONLINE_AMOUNT) >= 0) {
      lines = [...lines, { color: "#0ceb35", keyName: "اینترنتی" }];
    }
    if (chartLines.indexOf(CASH_AMOUNT) >= 0) {
      lines = [...lines, { color: "#551fd1", keyName: "نقدی" }];
    }
    return lines;
  };
  const chartData = !_.isEmpty(dashboard)
    ? {
        data: _.map(dashboard.dailySale, (dailySale) => {
          return {
            NAME: dailySale.jalaliDate,
            مجموع: dailySale.totalSale,
            ...paymentTypeBasedSales(dailySale.sales),
          };
        }),
        lines: getlines(),
        margin: {
          top: 30,
          right: 30,
          left: 20,
          bottom: 5,
        },
      }
    : null;
  const toggleChartLines = (TYPE) => {
    console.log(chartLines);
    if (_.indexOf(chartLines, TYPE) >= 0) {
      setChartLines(_.filter(chartLines, (chartLine) => chartLine !== TYPE));
    } else {
      setChartLines([...chartLines, TYPE]);
    }
  };

  return (
    <div className="contentItems">
      <div className="sizeHandler_1185">
        <div className="dashboardLists">
          <a href={`/dashboard/bookSales/${id}`} className="smallBox redBackground whiteColor">
            <div className="rightCounter">
              <span className="icon icon-sold  font-size_45 blockInline middleContext"></span>
              <span className=" font-size_45 mediumWFont blockInline middleContext">
                {!_.isEmpty(dashboard) ? dashboard.dashboardModel.booksSold : 0}
              </span>
            </div>
            <div className="leftContent">
              <div className="leftContentTitle">
                <span className="bigTitle font-size_24">کتاب</span>
                <p className="font-size_18 lightFont">فروخته شده</p>
              </div>
              <span className="icon icon-arrow-left leftFloat boxArrow"></span>
            </div>
          </a>
          <a
             href={`/dashboard/books/${id}`}
            className="smallBox darkGreenBackground whiteColor"
          >
            <div className="rightCounter">
              <span className="icon icon-book  font-size_45 blockInline middleContext"></span>
              <span className=" font-size_45 mediumWFont blockInline middleContext">
                {!_.isEmpty(dashboard)
                  ? dashboard.dashboardModel.booksCount
                  : 0}
              </span>
            </div>
            <div className="leftContent">
              <div className="leftContentTitle">
                <span className="bigTitle font-size_24">عنوان</span>
                <p className="font-size_18 lightFont">کتاب</p>
              </div>
              <span className="icon icon-arrow-left leftFloat boxArrow"></span>
            </div>
          </a>
          <a href={`/dashboard/orders/${id}`} className="smallBox purpleBackground whiteColor">
            <div className="rightCounter">
              <span className="icon icon-orders  font-size_45 blockInline middleContext"></span>
              <span className=" font-size_45 mediumWFont blockInline middleContext">
                {!_.isEmpty(dashboard)
                  ? dashboard.dashboardModel.ordersCount
                  : 0}
              </span>
            </div>
            <div className="leftContent">
              <div className="leftContentTitle">
                <span className="bigTitle font-size_24">سفارش</span>
                <p className="font-size_18 lightFont">ثبت شده</p>
              </div>
              <span className="icon icon-arrow-left leftFloat boxArrow"></span>
            </div>
          </a>
          <div className="mediumBox greenBackground whiteColor topColumnMargin">
            <div className="rightCounter">
              <span className="bestSellBack middleContext">
                <img
                  className="bestSellImage"
                  src={
                    !_.isEmpty(dashboard)
                      ? dashboard.dashboardModel.bestSoldBookImage
                      : null
                  }
                />
              </span>
              <div className="leftContentTitle middleContext">
                <span className="bigTitle font-size_24">پرفروش ترین کتاب</span>
                <p className="bestSeller font-size_18 lightFont">
                  {!_.isEmpty(dashboard)
                    ? dashboard.dashboardModel.bestSoldBookName
                    : null}
                </p>
              </div>
            </div>
            <div className="leftContent textInLeft">
              <div className="copies lightFont">
                <span className="mediumWFont font-size_24">
                  {!_.isEmpty(dashboard)
                    ? dashboard.dashboardModel.bestSoldCount
                    : 0}
                </span>
                جلد
              </div>
              <div className="sell lightFont">
                <span className="mediumWFont font-size_24">
                  {!_.isEmpty(dashboard)
                    ? dashboard.dashboardModel.bestSoldTotalAmount.toLocaleString()
                    : 0}
                </span>
                فروش
              </div>
            </div>
          </div>
          <a
            href={`/dashboard/customers/${id}`}
            className="smallBox orangeBackground whiteColor topColumnMargin"
          >
            <div className="rightCounter">
              <span className="icon icon-customer  font-size_45 blockInline middleContext"></span>
              <span className=" font-size_45 mediumWFont blockInline middleContext">
                {!_.isEmpty(dashboard)
                  ? dashboard.dashboardModel.customersCount
                  : 0}
              </span>
            </div>
            <div className="leftContent">
              <div className="leftContentTitle">
                <span className="bigTitle font-size_24">مشتری</span>
                <p className="font-size_18 lightFont">ثبت شده</p>
              </div>
              <span className="icon icon-arrow-left leftFloat boxArrow"></span>
            </div>
          </a>
        </div>
        <div className="totalSells organizer">
          <div className="allTimeSell organizer">
            <div className="totalSellTitle font-size_24 boldFont rightFloat">
              فروش کل
            </div>
            <div className="totalSellNumber font-size_45 boldFont greenColor leftFloat">
              {!_.isEmpty(dashboard)
                ? dashboard.saleInfo.totalAmount.toLocaleString()
                : 0}
              <span className="totalUnit font-size_18 mediumWFont">ریال</span>
            </div>
          </div>
          <div className="detailesSell organizer">
            <div className="rightColumn">
              <div className="posSell sellRow">
                <div className="sellTitle blockInline">
                  <span className="icon icon-pos font-size_35 middleContext"></span>
                  <span className="middleContext font-size_18 boldFont">
                    کارتخوان
                  </span>
                  <span className="icon icon-arrow-left font-size_14 leftFloat"></span>
                </div>
                <div className="orderNumber blockInline">{` ${
                  paymentTypes && paymentTypes[1] ? paymentTypes[1].count : 0
                } سفارش `}</div>
                <div className="sellNumber greenColor leftFloat boldFont">
                  {paymentTypes && paymentTypes[1]
                    ? paymentTypes[1].totalAmount.toLocaleString()
                    : 0}
                  <span className="sellUnit font-size_12 lightFont">ریال</span>
                </div>
              </div>
              <div className="cartSell sellRow">
                <div className="sellTitle blockInline">
                  <span className="icon icon-creditcard font-size_35 middleContext"></span>
                  <span className="middleContext font-size_18 boldFont">
                    کارت به کارت
                  </span>
                  <span className="icon icon-arrow-left font-size_14 leftFloat"></span>
                </div>
                <div className="orderNumber blockInline">{` ${
                  paymentTypes && paymentTypes[2] ? paymentTypes[2].count : 0
                } سفارش `}</div>
                <div className="sellNumber greenColor leftFloat boldFont">
                  {paymentTypes && paymentTypes[2]
                    ? paymentTypes[2].totalAmount.toLocaleString()
                    : 0}
                  <span className="sellUnit font-size_12 lightFont">ریال</span>
                </div>
              </div>
            </div>
            <div className="leftColumn">
              <div className="cashSell sellRow">
                <div className="sellTitle blockInline">
                  <span className="icon icon-wallet font-size_30 middleContext"></span>
                  <span className="middleContext font-size_18 boldFont">
                    نقدی
                  </span>
                  <span className="icon icon-arrow-left font-size_14 leftFloat"></span>
                </div>
                <div className="orderNumber blockInline">{` ${
                  paymentTypes && paymentTypes[4] ? paymentTypes[4].count : 0
                } سفارش `}</div>
                <div className="sellNumber greenColor leftFloat boldFont">
                  {paymentTypes && paymentTypes[4]
                    ? paymentTypes[4].totalAmount.toLocaleString()
                    : 0}
                  <span className="sellUnit font-size_12 lightFont">ریال</span>
                </div>
              </div>
              <div className="onlineSell sellRow">
                <div className="sellTitle blockInline">
                  <span className="icon icon-online-payment font-size_35 middleContext"></span>
                  <span className="middleContext font-size_18 boldFont">
                    آنلاین
                  </span>
                  <span className="icon icon-arrow-left font-size_14 leftFloat"></span>
                </div>
                <div className="orderNumber blockInline">{` ${
                  paymentTypes && paymentTypes[3] ? paymentTypes[3].count : 0
                } سفارش `}</div>
                <div className="sellNumber greenColor leftFloat boldFont">
                  {paymentTypes && paymentTypes[3]
                    ? paymentTypes[3].totalAmount.toLocaleString()
                    : 0}
                  <span className="sellUnit font-size_12 lightFont">ریال</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sortChart organizer">
          <div onClick={() => toggleChartLines(TOTAL_AMOUNT)}>
            {_.indexOf(chartLines, TOTAL_AMOUNT) >= 0 ? (
              <span className="icon icon-check"></span>
            ) : null}
            همه
          </div>
          <div onClick={() => toggleChartLines(POS_AMOUNT)}>
            {_.indexOf(chartLines, POS_AMOUNT) >= 0 ? (
              <span className="icon icon-check"></span>
            ) : null}
            کارتخوان
          </div>
          <div onClick={() => toggleChartLines(CARD_AMOUNT)}>
            {_.indexOf(chartLines, CARD_AMOUNT) >= 0 ? (
              <span className="icon icon-check"></span>
            ) : null}
            کارت به کارت
          </div>
          <div onClick={() => toggleChartLines(CASH_AMOUNT)}>
            {_.indexOf(chartLines, CASH_AMOUNT) >= 0 ? (
              <span className="icon icon-check"></span>
            ) : null}
            نقدی
          </div>
          <div onClick={() => toggleChartLines(ONLINE_AMOUNT)}>
            {_.indexOf(chartLines, ONLINE_AMOUNT) >= 0 ? (
              <span className="icon icon-check"></span>
            ) : null}
            اینترنتی
          </div>
        </div>
        <div className="chart organizer">
          <LinearChart chartData={chartData} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  dashboard: state.dashboard,
});

export default connect(mapStateToProps, {})(withRouter(MainPage));
